module.exports = {
  Appliance: require('./Appliance'),
  Cars: require('./Cars'),
  Ereader: require('./Ereader'),
  Gaming: require('./Gaming'),
  Gps: require('./Gps'),
  Media: require('./Media'),
  Mobile: require('./Mobile'),
  Pda: require('./Pda'),
  Phone: require('./Phone'),
  Printer: require('./Printer'),
  Signage: require('./Signage'),
  Tablet: require('./Tablet'),
  Television: require('./Television'),
};
